<main *transloco="let t">
  <section class="wallpaper"></section>

  <section class="content">
    <!-- Loading state -->
    @if (status() === 'loading') {
      <div class="state-wrapper">
        <mat-spinner diameter="48"></mat-spinner>
        <p class="state-text">{{ t('Confirming transfer...') }}</p>
      </div>
    }

    <!-- Success state -->
    @if (status() === 'success') {
      <div class="state-wrapper">
        <div class="logo-wrapper"><p class="logo"></p></div>

        <div class="icon-circle success-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M5 12l5 5 9-9"
              stroke="#ffffff"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <h2>{{ t('Transfer Confirmed!') }}</h2>

        <p class="description">
          {{
            t(
              'The pet has been successfully transferred to your account. Open the Anihis app to find it in your dashboard.'
            )
          }}
        </p>

        <p class="countdown">
          {{ t('Opening the app in') }} <strong>{{ countdown() }}</strong>
          {{ t('seconds.') }}
        </p>

        <button class="open-app-btn" (click)="openApp()">
          {{ t('Open Anihis App') }}
        </button>

        <p class="hint">
          {{ t("Don't have the app yet?") }}
        </p>

        <a
          class="store-link"
          [href]="getAppStoreUrl()"
          target="_blank"
          rel="noopener"
        >
          {{ t('Download Anihis') }}
        </a>
      </div>
    }

    <!-- Error state -->
    @if (status() === 'error') {
      <div class="state-wrapper">
        <div class="logo-wrapper"><p class="logo"></p></div>

        <div class="icon-circle error-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18 6L6 18M6 6l12 12"
              stroke="#ffffff"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <h2>{{ t('Transfer Failed') }}</h2>
        <p class="description error-text">{{ errorMessage() }}</p>

        <p class="hint">
          {{ t('If you believe this is a mistake, please contact support.') }}
        </p>
      </div>
    }
  </section>
</main>
